export const GET_GENERATE_VOUCHER_OPTIONS = 'GET_GENERATE_VOUCHER_OPTIONS'
export const GET_GENERATE_VOUCHER_STUDENTS = 'GET_GENERATE_VOUCHER_STUDENTS'
export const PREVIEW_GENERATE_VOUCHERS = 'PREVIEW_GENERATE_VOUCHERS'
export const GET_GENERATE_VOUCHER_PREVIEW_STUDENTS = 'GET_GENERATE_VOUCHER_PREVIEW_STUDENTS'
export const CREATE_GENERATE_VOUCHER_RUN = 'CREATE_GENERATE_VOUCHER_RUN'
export const GET_CURRENT_GENERATE_VOUCHER_RUN = 'GET_CURRENT_GENERATE_VOUCHER_RUN'
export const GET_GENERATE_VOUCHER_RUN = 'GET_GENERATE_VOUCHER_RUN'
export const GET_GENERATE_VOUCHER_RUNS = 'GET_GENERATE_VOUCHER_RUNS'
export const RUN_GENERATE_VOUCHER_CHUNK = 'RUN_GENERATE_VOUCHER_CHUNK'
export const CHECK_GENERATE_VOUCHER_CHUNK = 'CHECK_GENERATE_VOUCHER_CHUNK'
export const CLOSE_GENERATE_VOUCHER_RUN = 'CLOSE_GENERATE_VOUCHER_RUN'
